__turbopack_context__.v({
  "container": "Link-module__n2YCGW__container",
});
